module.exports = __webpack_public_path__ + "mobile/img/crm-img13.40192ef2.png";